import { useBookingEditModeStoreActions } from "PFApp/booking/booking_edit_mode_store";
import { useBookingModuleStore, useWorkforceProfilesDataIfAvailable } from "PFApp/booking/store";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { useEffect } from "react";

export const useResetPendingEditsOnGranularityChange = () => {
  const { smartPlannerMode } = useBookingEditModeStoreActions();

  const { calendarGranularity: workforceGranularity } =
    useWorkforceProfilesDataIfAvailable("calendarGranularity");
  const projectsEngagementsGranularity = useBookingModuleStore(
    (state) => state[CalendarRoot.ProjectsEngagements].calendarGranularity
  );
  const projectsRolesGranularity = useBookingModuleStore(
    (state) => state[CalendarRoot.ProjectsRoles].calendarGranularity
  );

  useEffect(() => {
    smartPlannerMode.resetPendingEdits();
  }, [workforceGranularity, projectsEngagementsGranularity, projectsRolesGranularity]); // eslint-disable-line react-hooks/exhaustive-deps
};
